import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-landing.dialog',
    templateUrl: './landing.dialog.component.html',
    styleUrl: './landing.dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LandingDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LandingDialogComponent>
  ) {}

  // Close dialog and send choice back to caller
  closeDialog(choice: string): void {
    this.dialogRef.close(choice);
  }
}
